class MadToggleButtons {
  constructor(container) {
    this.container = container;
    
    // Check if the container already has a group identifier.
    let group = this.container.data('toggle-group');
    if (!group) {
      group = this._generateRandomHash();
      this.container.attr('data-toggle-group', group);
    }
    this.group = group;
    
    // 1. Process the buttons first.
    this.buttons = this.container.find('.mad-toggle__button[data-button-toggle-id]');
    this.buttons.each((index, button) => {
      const $button = jQuery(button);
      // Add the group attribute to the button if it doesn't have one.
      if (!$button.attr('data-toggle-group')) {
        $button.attr('data-toggle-group', group);
      }
    });
    
    // 2. For each button, find matching toggle content elements and assign the group.
    // This covers both elements that should be shown (data-toggle-id)
    // and those that should be hidden when active (data-toggle-id-inactive).
    this.buttons.each((index, button) => {
      const toggleId = jQuery(button).data('button-toggle-id');
      // Process standard toggle elements.
      jQuery(`[data-toggle-id="${toggleId}"]`).each((i, el) => {
        const $el = jQuery(el);
        if (!$el.attr('data-toggle-group')) {
          $el.attr('data-toggle-group', group);
        }
      });
      // Process reverse toggle elements.
      jQuery(`[data-toggle-id-inactive="${toggleId}"]`).each((i, el) => {
        const $el = jQuery(el);
        if (!$el.attr('data-toggle-group')) {
          $el.attr('data-toggle-group', group);
        }
      });
    });
    
    this.init();
  }
  
  // Helper: Generate a short random hash (e.g., 6 characters).
  _generateRandomHash() {
    return Math.random().toString(36).substring(2, 8);
  }
  
  init() {
    this.buttons.on('click', (event) => {
      const button = jQuery(event.currentTarget);
      const toggleId = button.data('button-toggle-id');
      this.setActiveToggle(toggleId, button);
    });
    
    this.buttons.on('mouseenter', function() {
      const $button = jQuery(this);
      setTimeout(() => {
        $button.trigger('click');
      }, 150);
    });
    
  }
  
  /**
   * Sets the active state based on the given toggleId.
   *
   * For elements with data-toggle-id: if their value equals toggleId,
   * they get the "active" class.
   *
   * For elements with data-toggle-id-inactive: if their value equals toggleId,
   * they remain hidden (no "active" class); if not, they get the "active" class.
   *
   * Finally, the clicked button is marked active.
   */
  setActiveToggle(toggleId, clickedButton) {
    const group = this.group;
    
    // Process elements meant to be shown when toggled.
    const activeElements = jQuery(`[data-toggle-id][data-toggle-group="${group}"]`);
    activeElements.removeClass('active');
    
    // Process elements meant to be hidden when this toggle is active.
    const reverseElements = jQuery(`[data-toggle-id-inactive][data-toggle-group="${group}"]`);
    reverseElements.removeClass('active');
    
    // Activate the standard toggle element(s) matching toggleId.
    const targetElement = jQuery(`[data-toggle-id="${toggleId}"][data-toggle-group="${group}"]`);
    if (targetElement.length > 0) {
      targetElement.addClass('active');
    }
    
    // For reverse toggle elements, add "active" only if their value does NOT match toggleId.
    reverseElements.each((i, el) => {
      const $el = jQuery(el);
      if ($el.attr('data-toggle-id-inactive') !== toggleId) {
        $el.addClass('active');
      }
    });
    
    // Update the toggle buttons.
    const allButtons  = jQuery(`[data-button-toggle-id][data-toggle-group="${group}"]`);
    allButtons.removeClass('active');
    clickedButton.addClass('active');
  }
}

class MadToggleNavigation {
  constructor(container) {
    this.container = container;

    // Vor-/Zurück-Buttons ermitteln
    this.prevButton = this.container.find('[data-button-toggle-navigation="prev"]');
    this.nextButton = this.container.find('[data-button-toggle-navigation="next"]');

    // IDs aus dem Attribut data-toggle-nav-ids auslesen
    const idsString = this.container.data('toggle-nav-ids') || '';
    this.ids = idsString
      .split(',')
      .map((id) => id.trim())
      .filter((id) => id.length > 0);

    // Events initialisieren
    this.init();
  }

  init() {
    this.prevButton.on('click', () => {
      this.showPrevious();
    });
    this.nextButton.on('click', () => {
      this.showNext();
    });
  }

  showNext() {
    // Aktiven Index ermitteln
    let activeIndex = this.getActiveIndex();

    if (activeIndex === -1) {
      // Falls kein Element aktiv ist, das erste aktivieren
      this.activateByIndex(0);
    } else {
      // Nächstes Element aktivieren
      const nextIndex = (activeIndex + 1) % this.ids.length;
      this.activateByIndex(nextIndex);
    }
  }

  showPrevious() {
    let activeIndex = this.getActiveIndex();
    if (activeIndex === -1) {
      // Falls kein Element aktiv ist, das letzte aktivieren
      this.activateByIndex(this.ids.length - 1);
    } else {
      let prevIndex = activeIndex - 1;
      if (prevIndex < 0) {
        prevIndex = this.ids.length - 1;
      }
      this.activateByIndex(prevIndex);
    }
  }

  /**
   * Ermittelt den Index des aktuell aktiven Toggle-Elements.
   * Gibt -1 zurück, wenn kein Element aktiv ist.
   */
  getActiveIndex() {
    let foundIndex = -1;
    for (let i = 0; i < this.ids.length; i++) {
      const id = this.ids[i];
      const $el = jQuery(`[data-toggle-id="${id}"]`);
      if ($el.hasClass('active')) {
        foundIndex = i;
        break;
      }
    }
    return foundIndex;
  }

  /**
   * Deaktiviert alle Toggle-Elemente und aktiviert das Element,
   * dessen ID dem übergebenen Index in this.ids entspricht.
   */
  activateByIndex(index) {
    if (index < 0 || index >= this.ids.length) {
      return;
    }

    // Alle Toggle-Elemente anhand der IDs deaktivieren
    for (const id of this.ids) {
      jQuery(`[data-toggle-id="${id}"]`).removeClass('active');
    }

    // Das Element mit der ID an der angegebenen Position aktivieren
    const newId = this.ids[index];
    jQuery(`[data-toggle-id="${newId}"]`).addClass('active');

    // Optional: Falls Toggle-Buttons existieren, diese ebenfalls aktualisieren
    jQuery('.mad-toggle__button[data-button-toggle-id]').removeClass('active');
    jQuery(`.mad-toggle__button[data-button-toggle-id="${newId}"]`).addClass('active');
  }
}

jQuery(document).ready(function () {
  // 1) Standard-Buttons
  jQuery('.mad-toggle__container:has(.mad-toggle__button)').each(function () {
    new MadToggleButtons(jQuery(this));
  });

  // 2) Navigation
  jQuery('.mad-toggle__container.mad-toggle__container--navigation').each(function () {
    new MadToggleNavigation(jQuery(this));
  });
});
